import moment from 'moment-timezone';

import { DATE_FORMAT, getDefaultTimezone, TIME_FORMAT } from '@core/time-legacy';

import type { TimeData } from '../time-picker.component';

interface TimePickerBridgeInterface {
  convertComponentDataToMoment: (timeData: TimeData) => moment.Moment;
  convertMomentToComponentData: (moment: moment.Moment, timezone: string) => TimeData;
}

export class TimePickerBridge implements TimePickerBridgeInterface {
  public convertComponentDataToMoment(timeData: TimeData): moment.Moment {
    const { zone, time, date } = timeData;
    const momentDate = moment(`${date}, ${time}`, 'YYYY-MM-DD, hh:mm A');
    momentDate.tz(zone, true);

    return momentDate;
  }

  public convertMomentToComponentData(moment: moment.Moment, timezone: string | null): TimeData {
    return {
      date: moment.format(DATE_FORMAT),
      time: moment.format(TIME_FORMAT),
      zone: timezone || getDefaultTimezone(),
    };
  }
}
